<template>
  <div>   
    <footer id="footer">
    <div class="container">
      &copy; 2020 {{tenant_name}}
      <nav id="footerNav" aria-label="Main">
        <ul class="list-reset">
          <li><a :href="`${contactUrl}`" target="_blank">Contact</a></li>
          <li><a :href="`${aboutUrl}`" target="_blank">About</a></li>
        </ul>
      </nav>
    </div>
  </footer>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { UrlKeys } from "@/utils/enums";

export default {
  name: "Footer",
  data() {
    return {
      tenant_name: process.env.VUE_APP_TENANT_NAME,
    };
  },
  async created() {
    if (!this.aboutUrl)
      await this.fetchSiteUrl(UrlKeys.L2BAbout);

    if (!this.contactUrl)
      await this.fetchSiteUrl(UrlKeys.L2BContact);
  },
  computed: {
    ...mapState(["aboutUrl", "contactUrl"])
  },
  methods: {
    ...mapActions(["fetchSiteUrl"])
  }
};
</script>